import React from 'react'
import mockUp from "../../Photos/mock up.png"
import PortalButton from '../../Photos/ButtonPortal.png'
import backgroundImage  from '../../Photos/BackgroundHealthPortal.png'
import { motion } from "framer-motion";
import ContactColors from "../../Photos/ContactColors.png"


 const DataScienceHealth = () => {

/*   const { ref, inView } = useInView({
    triggerOnce: true, // anima solo una vez
    threshold: 0.2,     // porcentaje de visibilidad para activar
  }); */

  return (
    <> 
    <div  className='LandingFirstBlockDiv' style={{  backgroundImage: `url(${backgroundImage})`, backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat', borderBottomRightRadius:'10wv'}}>

<div className='LandingWeAreYMCDiv' >
        <div className='LandingFirstBlockInnerDiv'>
          <div className='LandingFirstBlockLeftSide'>
{/*           <div className='LandingWeAreYMCTopTitle'>Ciencia de Datos y Salud</div> */}

          <motion.h1       initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 2 }} className='LandingFirstBlockTitle'><span><b>Gestiona</b></span> tus <span><b>riesgos</b></span> de salud <span><b>antes</b></span> de <span><b>que</b></span> se transformen en <span><b>enfermedades!</b></span></motion.h1>
            <motion.div      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 2 }} className='LandingFirstBlockSubtitle'>Crea tu perfil médico, mide tus riesgos de salud y evalúa tus resultados.
              <br/>
              +YMC ¡para vivir más y mejor!
            </motion.div>
            <div className='LandingPurpleButtonDiv'>
            <a href="https://salud.yomecontrolo.cl/" style={{ textDecoration: 'none' }}>
             <div className='GeneralPurpleButtonFlex PurpleButtonBlock' style={{float:"center"}}> 
        <div className='PurpleButtonText'>
          Ir al portal de Salud +YMC
        </div>
        <div className='PurpleButtonIconPortal'>
          <img src={PortalButton}/>
        </div>
        </div>
        </a>
            </div>
          </div>
          <div className='LandingFirstBlockRightSide'>
            <motion.img      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }} alt="" className="LandingFirstBlockRightSideImage" src={mockUp}/>
          </div>
        </div>
      </div>

    </div>
 
    </>
  )
}
export default DataScienceHealth;